import { createUseStyles } from 'react-jss'

const useTabsStyle = createUseStyles(theme => ({
  tabs: {
    marginBottom: '1rem',
    display: 'flex',
  },
}))

export { useTabsStyle }
